<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="card">
      <div class="card-body">
        <ngb-alert [type]="'info'" [dismissible]="false">
          <div class="alert-body">
            Pick a subject and the form you want to do a quiz for and press
            start. Good luck.
          </div>
        </ngb-alert>
        <!-- form select -->
        <form action="#" [formGroup]="quizForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="form-group col-sm-3">
              <label for="basicSelect">Form</label
              ><select class="form-control" formControlName="form" (change)="fetchTopics()">
                <option>Select a Form</option>
                <option *ngFor="let form of form">{{ form }}</option>
              </select>
              <!-- <span *ngIf="quizForm.submitted" class="invalid-form">
                <small class="form-text text-danger" *ngIf="!selectedForm"
                  >Form must be selected!</small
                >
              </span> -->
            </div>
            <div class="form-group col-sm-3" required>
              <label for="basicSelect">Subject</label
              ><select
                class="form-control"
                formControlName="subject"
                (change)="fetchTopics()"
              >
                <option>Select a Subject</option>
                <option
                  [value]="subject.subjectId"
                  *ngFor="let subject of subjects"
                >
                  {{ subject.name }}
                </option>
              </select>
              <!-- <span *ngIf="quizForm.submitted" class="invalid-form">
                <small class="form-text text-danger" *ngIf="!selectedSubject"
                  >Subject must be selected!</small
                >
              </span> -->
            </div>
            <div class="form-group col-sm-3" required>
              <label for="basicSelect">Topic</label
              ><select class="form-control" formControlName="topic">
                <option disabled>Select a Topic</option>
                <option *ngFor="let topic of topics" [value]="topic.topicId">
                  {{ topic.title }}
                </option>
              </select>
              <!-- <span *ngIf="quizForm.submitted" class="invalid-form">
                <small class="form-text text-danger" *ngIf="!selectedTopic"
                  >Topic must be selected!</small
                >
              </span> -->
            </div>
            <div class="form-group col-sm-3">
              <ng-container *ngIf="currentUser && isStudent && !isSubscribed; else startQuiz">
                <button
                type="button"
                [disabled]="!quizForm.valid"
                (click)="triggerSubscriptionAlert()"
                class="btn btn-block btn-primary mr-1 waves-effect waves-float waves-light"
                style="margin-top: 24px"><i class="fa fa-lock"></i>  Start Quiz</button>
              </ng-container>
              <ng-template #startQuiz>
                <button
                type="submit"
                [disabled]="!quizForm.valid"
                class="btn btn-block btn-primary mr-1 waves-effect waves-float waves-light"
                style="margin-top: 24px"> Start Quiz</button>
              </ng-template>
            </div>
          </div>
        </form>
        <!-- form select -->
      </div>
    </div>

    <!-- Quiz Performance -->
    <ng-container *ngIf="isStudent && isSubscribed">
    <app-quiz-performance [isStudent]="true" [form]="studentForm" [height]="35"></app-quiz-performance>
  </ng-container>
  </div>
</div>
